import { makeStyles } from "@material-ui/core";
import { colors } from "../../shared/utils/colors";

const useStyles = makeStyles({
  panel: {
    padding: "24px",
    borderRadius: 16,
    flex: 1,
    border: "1px solid #d9d9d9",
  },
  title: {
    color: colors.blueDarken,
    fontSize: 22,
    marginBottom: 20,
  },
  field: {
    marginBottom: 14,
    flex: 1,
    minWidth: 0,
  },
  fila: {
    display: "flex",
    gap: 16,
  },
  value: {
    color: colors.blueDarken,
    fontWeight: "bold",
    fontSize: 18,
    paddingBottom: 4,
    borderBottom: "1px solid #c8cede",
  },
  label: {
    fontSize: 11,
    color: colors.greyFont,
    marginTop: 2,
    display: "block",
  },
});

export default useStyles;
